import { render, staticRenderFns } from "./RolePermissions.vue?vue&type=template&id=b95f358e&scoped=true&"
import script from "./RolePermissions.vue?vue&type=script&lang=js&"
export * from "./RolePermissions.vue?vue&type=script&lang=js&"
import style0 from "./RolePermissions.vue?vue&type=style&index=0&id=b95f358e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95f358e",
  null
  
)

export default component.exports